export const Intelligence = () => {
	return (
		<div>
			<svg
				width="48"
				height="48"
				viewBox="0 0 48 48"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="Group 626186">
					<path
						id="Vector (Stroke)"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M37.3027 23.8756C37.3027 22.4546 38.4547 21.3027 39.8757 21.3027H44.5842C46.0052 21.3027 47.1572 22.4546 47.1572 23.8756C47.1572 25.2967 46.0052 26.4486 44.5842 26.4486H39.8757C38.4547 26.4486 37.3027 25.2967 37.3027 23.8756Z"
						fill="url(#paint0_linear_2487_5195)"
					/>
					<path
						id="Vector (Stroke)_2"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M24.0007 0.718933C25.4217 0.718933 26.5737 1.87089 26.5737 3.2919V8.00043C26.5737 9.42144 25.4217 10.5734 24.0007 10.5734C22.5797 10.5734 21.4277 9.42144 21.4277 8.00043V3.2919C21.4277 1.87089 22.5797 0.718933 24.0007 0.718933Z"
						fill="url(#paint1_linear_2487_5195)"
					/>
					<path
						id="Vector (Stroke)_3"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M0.84375 23.8756C0.84375 22.4546 1.99571 21.3027 3.41672 21.3027H8.12525C9.54626 21.3027 10.6982 22.4546 10.6982 23.8756C10.6982 25.2967 9.54626 26.4486 8.12525 26.4486H3.41672C1.99571 26.4486 0.84375 25.2967 0.84375 23.8756Z"
						fill="url(#paint2_linear_2487_5195)"
					/>
					<path
						id="Vector (Stroke)_4"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M24.0007 37.1779C25.4217 37.1779 26.5737 38.3298 26.5737 39.7508V44.4594C26.5737 45.8804 25.4217 47.0323 24.0007 47.0323C22.5797 47.0323 21.4277 45.8804 21.4277 44.4594V39.7508C21.4277 38.3298 22.5797 37.1779 24.0007 37.1779Z"
						fill="url(#paint3_linear_2487_5195)"
					/>
					<path
						id="Vector (Stroke)_5"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M29.9001 29.7752C30.9049 28.7703 32.534 28.7703 33.5388 29.7752L43.8307 40.067C44.8355 41.0718 44.8355 42.7009 43.8307 43.7058C42.8259 44.7106 41.1968 44.7106 40.192 43.7058L29.9001 33.4139C28.8953 32.4091 28.8953 30.78 29.9001 29.7752Z"
						fill="white"
					/>
					<path
						id="Vector (Stroke)_6"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M43.8307 4.04548C44.8355 5.05028 44.8355 6.6794 43.8307 7.6842L33.5388 17.9761C32.534 18.9809 30.9049 18.9809 29.9001 17.9761C28.8953 16.9713 28.8953 15.3422 29.9001 14.3373L40.192 4.04548C41.1968 3.04067 42.8259 3.04067 43.8307 4.04548Z"
						fill="white"
					/>
					<path
						id="Vector (Stroke)_7"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M4.16962 4.04548C5.17443 3.04067 6.80354 3.04067 7.80835 4.04548L18.1002 14.3373C19.105 15.3422 19.105 16.9713 18.1002 17.9761C17.0954 18.9809 15.4663 18.9809 14.4615 17.9761L4.16962 7.6842C3.16481 6.6794 3.16481 5.05028 4.16962 4.04548Z"
						fill="white"
					/>
					<path
						id="Vector (Stroke)_8"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M18.1002 29.7752C19.105 30.78 19.105 32.4091 18.1002 33.4139L7.80835 43.7058C6.80354 44.7106 5.17443 44.7106 4.16962 43.7058C3.16481 42.7009 3.16481 41.0718 4.16962 40.067L14.4615 29.7752C15.4663 28.7703 17.0954 28.7703 18.1002 29.7752Z"
						fill="white"
					/>
				</g>
				<defs>
					<linearGradient
						id="paint0_linear_2487_5195"
						x1="47.1571"
						y1="23.8756"
						x2="38.1517"
						y2="23.8756"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset="0.270833" stopColor="#9BC6FF" />
						<stop offset="1" stopColor="white" />
					</linearGradient>
					<linearGradient
						id="paint1_linear_2487_5195"
						x1="25.2872"
						y1="0.718933"
						x2="25.2872"
						y2="9.72432"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset="0.1875" stopColor="#9BC6FF" />
						<stop offset="1" stopColor="white" />
					</linearGradient>
					<linearGradient
						id="paint2_linear_2487_5195"
						x1="10.6981"
						y1="23.8756"
						x2="1.69272"
						y2="23.8756"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" />
						<stop offset="0.791667" stopColor="#2684FF" />
					</linearGradient>
					<linearGradient
						id="paint3_linear_2487_5195"
						x1="25.2872"
						y1="36.7404"
						x2="25.2872"
						y2="47.0323"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" />
						<stop offset="0.802083" stopColor="#A6CCFE" />
					</linearGradient>
				</defs>
			</svg>
		</div>
	);
};
